// extracted by mini-css-extract-plugin
module.exports = {"title":"_aab345e","container":"_650e7fb","info":"_4e7b1ae"};